import {
  type HistoryOptions,
  parseAsString,
  useQueryState,
} from '@vrplatform/query-params';
import { useMemo } from 'react';
import { removeDrawerStateFromUrl } from '../utils';

export function useConnectionDetailDrawer() {
  const [connectionId, set] = useQueryState(
    'connectionDetailId',
    parseAsString
  );

  return useMemo(
    () => ({
      opened: !!connectionId,
      open: (id: string, type?: HistoryOptions) => {
        removeDrawerStateFromUrl();
        set(id, {
          history: type || 'push',
        });
      },
      close: () => set(null),
      connectionId,
    }),
    [connectionId, set]
  );
}

export const useConnectionConnectModal = () => {
  const [connectionId, setConnectionId] = useQueryState(
    'connectionId',
    parseAsString
  );

  return useMemo(
    () => ({
      reconnect: (id: string) => {
        setConnectionId(id ?? null);
      },
      connectionId,
    }),
    [connectionId, setConnectionId]
  );
};
